import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const ProxyType = 'test'
export function getToken() {
  return ((window.location.href.split("token=")[1] ? window.location.href.split("token=")[1].replace("%3A", ":") : "") || localStorage.getItem("token") || Cookies.get(TokenKey))
}
export function getPreType() {
  return ProxyType
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
